/* eslint-disable react/jsx-no-target-blank */
import React, { useState, useRef } from "react";
import Typical from "react-typical";
import imgBack from "../../../src/images/mailz.jpeg";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";

import "./ContactMe.css";

import emailjs from "@emailjs/browser";

const Results = () => {
  return (
    <p style={{ color: "green", padding: "20px", fontWeight: "bold" }}>
      > Your message has been successfully sent ✅
    </p>
  );
};

export default function ContactMe(props) {
  const [results, setResults] = useState(false);
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_12a673s",
        "template_s0kk4g9",
        form.current,
        "MDaoH8yGvOU2JIVdR"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );

    e.target.reset();
    setResults(true);
  };

  return (
    <div className="main-container" id="contactMe">
      <ScreenHeading subHeading={"Let's keep in touch"} title={"Contact Me"} />
      <div className="central-form">
        <div className="col">
          <h2 className="title">
            <Typical loop={Infinity} steps={["Get In Touch ⌨", 1000]} />
          </h2>
          <a
            target="_blank"
            href="https://www.linkedin.com/in/devmonzer/"
            rel="noreferrer"
          >
            <i className="fa fa-linkedin fa-2x"></i>
          </a>
          <a target="_blank" href="https://github.com/DevMonzer">
            <i className="fa fa-github fa-2x"></i>
          </a>
          <a target="_blank" href="https://twitter.com/DevMonzer">
            <i className="fa fa-twitter fa-2x"></i>
          </a>
          <a
            target="_blank"
            href="https://www.facebook.com/profile.php?id=100075721583290"
          >
            <i className="fa fa-facebook-square fa-2x"></i>
          </a>
        </div>
        <div className="back-form">
          <div className="img-back">
            <h4>Send Me an Email</h4>
            <img src={imgBack} alt="no internet connection" />
          </div>
          <form ref={form} onSubmit={sendEmail}>
            <label htmlFor="name">Name</label>
            <input type="text" name="name" required />

            <label htmlFor="email" required>
              Email
            </label>
            <input type="text" name="email" />

            <label htmlFor="message" required>
              Message
            </label>
            <textarea type="text" name="message" />

            <div className="send-btn">
              <button type="submit">
                Send <i className="fa fa-paper-plane" />
              </button>
              <div> {results ? <Results /> : null}</div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
